(function () {
  function getLargeImage(img) {
    if (!img) return '';

    const srcset = img.getAttribute('srcset');
    if (srcset) {
      const sources = srcset.split(',').map((s) => s.trim()).filter(Boolean);
      const last = sources[sources.length - 1];
      if (last) return last.split(' ')[0];
    }

    return img.currentSrc || img.src || '';
  }

  function removeOldZoomElements() {
    document.querySelectorAll(
      '.amazon-zoom-lens, .amazon-zoom-box, .amazon-zoom-result, .amazon-final-lens, .amazon-final-zoom'
    ).forEach((el) => el.remove());
  }

  function getActiveSlide(swiperEl) {
    return swiperEl.querySelector('.swiper-slide-active') || swiperEl.querySelector('.swiper-slide.is-active');
  }

  function initAmazonFinalZoom() {
    if (window.innerWidth < 990) return;

    removeOldZoomElements();

    const gallery = document.querySelector('media-gallery');
    if (!gallery) return;

    const swiperEl = gallery.querySelector('.product-main-swiper');
    if (!swiperEl) return;

    const lens = document.createElement('div');
    lens.className = 'amazon-final-lens';

    const zoom = document.createElement('div');
    zoom.className = 'amazon-final-zoom';

    document.body.appendChild(lens);
    document.body.appendChild(zoom);

    function hideZoom() {
      lens.style.display = 'none';
      zoom.style.display = 'none';
    }

    function getCurrentImage() {
      const activeSlide = getActiveSlide(swiperEl);
      if (!activeSlide) return null;

      return activeSlide.querySelector('img');
    }

    function isMouseInsideRect(event, rect) {
      return (
        event.clientX >= rect.left &&
        event.clientX <= rect.right &&
        event.clientY >= rect.top &&
        event.clientY <= rect.bottom
      );
    }

    function setZoomBoxPosition(imgRect) {
      const gap = 24;
      const left = imgRect.right + gap;
      const top = imgRect.top;
      const availableWidth = window.innerWidth - left - 24;
      /* Right side space nathi to zoom show nahi karvu */
      if (availableWidth < 320) {
        hideZoom();
        return false;
      }
    const width = Math.min(availableWidth, 520);
    const height = Math.min(imgRect.height * 0.75, 420, window.innerHeight - top - 24);
      zoom.style.left = `${left}px`;
      zoom.style.top = `${top}px`;
      zoom.style.width = `${width}px`;
      zoom.style.height = `${height}px`;
      return true;
    }
    function moveZoom(event) {
    if (
        event.target.closest('.swiper-button-next') ||
        event.target.closest('.swiper-button-prev') ||
        event.target.closest('.swiper-pagination') ||
        event.target.closest('.swiper-pagination-bullet')
    ) {
        hideZoom();
        return;
    }

    const img = getCurrentImage();
    if (!img) {
        hideZoom();
        return;
    }

    const imgRect = img.getBoundingClientRect();

    if (!isMouseInsideRect(event, imgRect)) {
        hideZoom();
        return;
    }

    const largeImg = getLargeImage(img);
    if (!largeImg) {
        hideZoom();
        return;
    }

    const canShow = setZoomBoxPosition(imgRect);
    if (!canShow) return;

    const lensWidth = 240;
    const lensHeight = 240;

    let x = event.clientX - imgRect.left - lensWidth / 2;
    let y = event.clientY - imgRect.top - lensHeight / 2;

    x = Math.max(0, Math.min(x, imgRect.width - lensWidth));
    y = Math.max(0, Math.min(y, imgRect.height - lensHeight));

    lens.style.left = `${imgRect.left + x}px`;
    lens.style.top = `${imgRect.top + y}px`;
    lens.style.width = `${lensWidth}px`;
    lens.style.height = `${lensHeight}px`;
    lens.style.display = 'block';

    const cx = zoom.offsetWidth / lensWidth;
    const cy = zoom.offsetHeight / lensHeight;

    zoom.style.backgroundImage = `url("${largeImg}")`;
    zoom.style.backgroundSize = `${imgRect.width * cx}px ${imgRect.height * cy}px`;
    zoom.style.backgroundPosition = `-${x * cx}px -${y * cy}px`;
    zoom.style.display = 'block';
    }

    swiperEl.addEventListener('mousemove', moveZoom);
    swiperEl.addEventListener('mouseleave', hideZoom);
    swiperEl.addEventListener('click', function (event) {
  if (
    event.target.closest('.swiper-button-next') ||
    event.target.closest('.swiper-button-prev') ||
    event.target.closest('.swiper-pagination') ||
    event.target.closest('.swiper-pagination-bullet')
  ) {
    hideZoom();
  }
});

    window.addEventListener('scroll', hideZoom, { passive: true });
    window.addEventListener('resize', hideZoom);
  }

  window.initAmazonFinalZoom = initAmazonFinalZoom;

  document.addEventListener('DOMContentLoaded', function () {
    setTimeout(initAmazonFinalZoom, 800);
  });

  document.addEventListener('shopify:section:load', function () {
    setTimeout(initAmazonFinalZoom, 800);
  });
})();